export default function Footer() {
  return (
    <footer className="print:hidden bg-navy-dark px-4 sm:px-6 py-2 flex flex-col sm:flex-row items-center justify-between gap-1 text-center sm:text-left flex-shrink-0">
      <span className="font-georgia text-[10px] sm:text-xs text-gray-400">
        © {new Date().getFullYear()} Our Lady of Fatima Church, Tambaram
      </span>
      <span className="font-georgia text-[10px] sm:text-xs text-gold">
        office@fatimatambaram.org
      </span>
    </footer>
  );
}
